let onCopied: (() => void) | undefined;

/** Register UI feedback for successful copies (e.g. snackbar). */
export function setCopyFeedbackHandler(handler: (() => void) | undefined): void {
  onCopied = handler;
}

const popoutWindows = new Set<Window>();

/** Pop-out windows register so copies made inside them use their document. */
export function registerClipboardPopoutWindow(win: Window): () => void {
  popoutWindows.add(win);
  return () => {
    popoutWindows.delete(win);
  };
}

/** The clipboard API only works from the focused document (opener or a pop-out). */
function focusedDocument(): Document {
  if (document.hasFocus()) return document;
  for (const win of Array.from(popoutWindows)) {
    if (!win.closed && win.document.hasFocus()) return win.document;
  }
  return document;
}

export async function copyTextToClipboard(text: string): Promise<void> {
  const doc = focusedDocument();
  try {
    await (doc.defaultView ?? window).navigator.clipboard.writeText(text);
  } catch {
    const el = doc.createElement("textarea");
    el.value = text;
    el.style.position = "fixed";
    el.style.left = "-9999px";
    doc.body.appendChild(el);
    el.select();
    doc.execCommand("copy");
    doc.body.removeChild(el);
  }
  onCopied?.();
}
